import {makeAutoObservable} from 'mobx';
import {fetchLuckyWheel} from '@/shared/api/api';
import {LuckyType, SpriteConfigLucky, SpriteConfigNameLucky} from '@/entities/lucky/types';
import {RootStore} from "@/app/providers/StoreProvider";
import {createSprites, LUCKY_LAYOUT, SECTORS} from "@/entities/lucky/model/luckyLayout";
import {AREA} from "@/entities/game/model/gameLayout";


export class LuckyStore {

    constructor(private rootStore:RootStore) {
        makeAutoObservable(this);
    }

    private get userStore() {
        return this.rootStore.userStore;
    }
    private get gameStore() {
        return this.rootStore.gameStore;
    }
    private get modalStore() {
        return this.rootStore.modalStore;
    }

    scale = 1;

    isSpinning = false;
    lockSpin = false;

    serverWinner:number = -1;
    serverWinnerType:LuckyType = LuckyType.ENERGY;
    serverWinnerValue:number = 0;

    referralLink:string = '';

    sprites:SpriteConfigLucky[] = [];


    initGame = () =>{
        this.sprites = createSprites();
        const spriteWheel = this.sprites.find((x)=> x.name == SpriteConfigNameLucky.wheel);
        const spriteStick = this.sprites.find((x)=> x.name == SpriteConfigNameLucky.stick);
        const spriteCenter = this.sprites.find((x)=> x.name == SpriteConfigNameLucky.center);
        if (!spriteWheel || !spriteStick || !spriteCenter) {
            throw new Error("One or more required sprites are missing");
        }


        spriteWheel.width = spriteWheel.baseWidth * this.scale;
        spriteWheel.height = spriteWheel.baseHeight * this.scale;


        spriteWheel.x = AREA.x + spriteWheel.width/2;
        spriteWheel.y = spriteWheel.height/2 + LUCKY_LAYOUT.topPadding * this.scale;

        spriteStick.width = spriteStick.baseWidth * this.scale;
        spriteStick.height = spriteStick.baseHeight * this.scale;

        spriteStick.x = spriteWheel.x;
        spriteStick.y = (spriteStick.height/2);


        spriteCenter.width = spriteCenter.baseWidth * this.scale;
        spriteCenter.height = spriteCenter.baseHeight * this.scale;

        spriteCenter.x = spriteWheel.x;
        spriteCenter.y = spriteWheel.y;

    }


    fetchResultAndStop = async() => {
        if(this.userStore.gameInfo.user.wheel <= 0 || this.lockSpin) return;
        this.lockSpin = true;
        this.isSpinning = true;

        const spinResult = await fetchLuckyWheel();
        if(spinResult.success){
            this.isSpinning = false;

            this.userStore.gameInfo.user.wheel -= 1;
            this.serverWinnerType = spinResult.data.type;
            this.serverWinnerValue = spinResult.data.value;


            if(spinResult.data.type in SECTORS){
                this.serverWinner = SECTORS[spinResult.data.type][spinResult.data.value];
            }
        }
    }
    stopSpin = () =>{

        switch(this.serverWinnerType){
            case LuckyType.ENERGY:
                this.gameStore.addRawEnergy(this.serverWinnerValue);
                this.modalStore.open('lucky',{itemType:LuckyType.ENERGY})
                break;
            case LuckyType.EMPTY_NET_10:
                this.modalStore.open('lucky',{itemType:LuckyType.EMPTY_NET_10})
                break;
            case LuckyType.EMPTY_NET_25:
                this.modalStore.open('lucky',{itemType:LuckyType.EMPTY_NET_25})
                break;
            case LuckyType.OVI_FLEX_100:
                this.modalStore.open('lucky',{itemType:LuckyType.OVI_FLEX_100})
                break;
            default:
                const never:never = this.serverWinnerType;
        }

        this.serverWinner = -1;
        this.serverWinnerValue = 0;
        this.lockSpin = false;
        this.userStore.getGameInfo()
    }

    addRawWheel = (value:number) => {
        this.userStore.gameInfo.user.wheel += value;
    }
}
